import angular from "angular";
import template from "./leads.html";
import controller from "./leads.controlller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.leads", {
    url: "/leads",
    template: template,
    controller: controller,
    controllerAs: "vm",
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.crm.leads", [])
  .config(config)
  .controller("AdminLeadsController", controller);
